import './index.less';
import * as React from 'react';
import { Alert } from '@beehive/components';
import PropTypes from 'prop-types';
import { getLocaleAttr } from 'utils/locales';

export interface AlertProps {
  type?: 'success' | 'info' | 'warning' | 'error';
  closable?: boolean;
  closeText?: React.ReactNode;
  message: React.ReactNode;
  description?: React.ReactNode;
  onClose?: React.MouseEventHandler<HTMLAnchorElement>;
  /** Trigger when animation ending of Alert */
  afterClose?: () => void;
  showIcon?: boolean;
  style?: React.CSSProperties;
  prefixCls?: string;
  banner?: boolean;
  // 是否固定显示在窗口中心
  position?: 'fixed' | 'absolute';
  hideDelay?: number;
}

export interface ShowAlertHOCState {
  show?: boolean;
  alertProps: Partial<AlertProps>;
}

// 警告信息高阶组件
const showAlertHOC = (WrappedComponent: any) => {
  return class extends React.Component<any, ShowAlertHOCState> {

    public static contextTypes = {
      intl: PropTypes.object,
    };

    private alertRef: React.RefObject<typeof Alert>;
    private initAlertProps: Partial<AlertProps> = {
      showIcon: true,
      closable: false,
      position: 'fixed',
    };
    constructor(props: any) {
      super(props);
      this.state = {
        show: false,
        alertProps: {
          showIcon: true,
          closable: false,
          position: 'fixed',
        },
      };
      this.alertRef = React.createRef();
    }

    private showAlert = (params: AlertProps) => {
      const { intl } = this.context;
      const { hideDelay = 3000, style, ...others } = params;
      const maxWidth = getLocaleAttr(intl.locale).alertMaxWidth;
      const styleObj = { maxWidth, ...style };

      this.setState({
        show: true,
        alertProps: {
          ...this.initAlertProps,
          style: styleObj,
          ...others,
        },
      });
      setTimeout(() => {
        if (this.alertRef.current) {
          this.alertRef.current.handleClose();
        }
      }, hideDelay);
    }

    private hideAlert = () => {
      const { alertProps } = this.state;
      this.setState({
        show: false,
      }, () => {
        if (alertProps.afterClose) {
          alertProps.afterClose();
        }
      });
    }

    public render() {
      const { alertProps, show } = this.state;
      return (
        <div className="">
          {
            show && (
              <Alert
                {...alertProps}
                afterClose={this.hideAlert}
                ref={this.alertRef}
              />
            )
          }
          <WrappedComponent
            {...this.props}
            showAlert={this.showAlert}
          />
        </div>
      );
    }
  };
};

export default showAlertHOC;
